import {Booking} from "../../../../core/entities/booking/domain/models/booking.model";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class BookingActivationFinishedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(public readonly booking: Booking) {
  }
}
